import { AcubeJobType } from '@repo/database/browser';
import z from '@/lib/zod';
import { toLegacySubTab } from '@/lib/helpers/list-tabs';
import { ACUBE_JOBS_TABS } from '@/pages/acube-jobs/lib/acube-jobs-filters';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/** Filtri della lista dei job ACube, validati dal layout per lista e dettaglio. */
export const acubeJobsSearchSchema = commonSearchSchema
  .extend({
    /** Tab della tabella (come la webapp). */
    subTab: optionalSearchString(),
    /**
     * Link di prima (widget della dashboard, segnalibri): diventa `subTab`
     * e non esce dallo schema. Da rimuovere dopo il 2026-12-31.
     */
    status: optionalSearchString(),
    jobType: z.enum(AcubeJobType).nullish().catch(undefined),
    tenantId: optionalSearchString(),
  })
  .transform(({ status, ...search }) => ({
    ...search,
    subTab: toLegacySubTab({
      tabs: ACUBE_JOBS_TABS,
      subTab: search.subTab,
      legacyFilter: status,
    }),
  }));

export type AcubeJobsSearch = z.output<typeof acubeJobsSearchSchema>;
